// roomBookingSaga.ts
import { call, put, takeLatest } from "redux-saga/effects";
import { roomBookingActionTypes } from "./roomBookingTypes";
import { roomBookingApiResponseSuccess, roomBookingApiResponseError } from "./roomBookingActions";
import { showErrorNotification, showSuccessNotification } from "../../helpers/NotificationContext";
import { fetchRoomOptionsApi } from "../../api/room";
import { fetchBookingDetailsApi } from "../../api/room";
// import { approvedEntrySubmitApi } from "../../api/room";


function* fetchRoomOptionsSaga(action: any) {
  try {
    console.log("Fetching room options...");
    const response = yield call(fetchRoomOptionsApi);
    console.log("Backend response from fetchRoomOptionsApi: ", response);
    yield put(roomBookingApiResponseSuccess(roomBookingActionTypes.FETCH_ROOM_OPTIONS, response));
    showSuccessNotification(`🚀 Room options fetched successfully!`);

  } catch (error: any) {
    console.error("Saga error fetching room options:", error.message);
    yield put(roomBookingApiResponseError(roomBookingActionTypes.FETCH_ROOM_OPTIONS, error.message));
    showErrorNotification("Execution failed: " + error.message);
  }
}

function* fetchBookingDetailsSaga(action: any) {
  try {
    const selectedRoomNumber = action.payload;
    console.log("Fetching booking details for room number:", selectedRoomNumber);
    const response = yield call(fetchBookingDetailsApi, selectedRoomNumber);
    console.log("Backend response from fetchBookingDetailsApi: ", response);
    yield put(roomBookingApiResponseSuccess(roomBookingActionTypes.FETCH_BOOKING_DETAILS, response));
    showSuccessNotification(`🚀 Booking details fetched successfully!`);

  } catch (error: any) {
    console.error("Saga error fetching booking details:", error.message);
    yield put(roomBookingApiResponseError(roomBookingActionTypes.FETCH_BOOKING_DETAILS, error.message));
    showErrorNotification("Execution failed: " + error.message);
  }
}





// Root saga to watch for the actions
export default function* roomBookingSaga() {
  yield takeLatest(roomBookingActionTypes.FETCH_ROOM_OPTIONS, fetchRoomOptionsSaga);
  yield takeLatest(roomBookingActionTypes.FETCH_BOOKING_DETAILS, fetchBookingDetailsSaga);
  // yield takeLatest(roomBookingActionTypes.APPROVED_ENTRY_SUBMIT, approvedEntrySubmitSaga);

}
